export const projects = [
  {
    categoryId: "cat-enclosure",
    categoryName: "Enclosure",
    categoryDescription:
      "Custom-engineered acoustic and weather-proof enclosures designed for power generation and industrial equipment, featuring advanced noise attenuation and climate control.",
    categoryImage:
      "https://media.arcengltd.com/project-images/ARC_Enclosure.webp",
    projects: [
      {
        id: "ENC-001",
        name: "20ft Custom Enclosure for C1100D5B",
        client: "Cummins Arabia",
        type: "Enclosure",
        location: "Sajja",
        description: [
          "Design and Supply of 3 numbers of 20ft. Custom built Enclosure with 2,000 Ltr Single wall Base fuel Tank with instrumentation for C1100D5B Genset (Dimensions, L=6.058 m x W=2.438 m & H=2.890 m) (Noise Level: 85 dB (A) @ 3 m in a free field environment)",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins Arabia_01.webp",
        ],
        color: "from-black-900 to-black-500",
      },
      {
        id: "ENC-002",
        name: "Multi-Capacity Genset Enclosure Series",
        client: "ADNOC",
        type: "Enclosure",
        location: "Sajja",
        description: [
          "Enclosure for 80KVA Genset:",
          [
            "Compact design for small-scale power needs",
            "Noise reduction features for quiet operation",
            "Durable construction for long-term reliability",
          ],
          "Enclosure for 200KVA Genset:",
          [
            "Engineered for medium power requirements",
            "Integrated ventilation and cooling systems",
            "Weather-resistant design for outdoor use",
          ],
          "Enclosure for 325KVA Genset:",
          [
            "Custom-built for specific power needs",
            "Enhanced noise attenuation features",
            "Robust structure for harsh environments",
          ],
          "Enclosure for 1000KVA Genset:",
          [
            "Large-scale power solution with advanced features",
            "Optimized for high-performance and safety",
            "Integrated systems for efficient operation and maintenance",
          ],
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_ADNOC_01.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_ADNOC_02.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_ADNOC_03.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_ADNOC_04.webp",
        ],
        color: "from-black-900 to-black-500",
      },
      {
        id: "ENC-003",
        name: "1250KVA (KTA50G3) High-Acoustic Packaging",
        client: "ENERGIA MTC LLC",
        type: "Enclosure",
        location: "Sajja",
        description: [
          "Design, Supply and Packaging of 5 nos. of Custom-built Enclosure (L= 8.8 m X W= 2.7 m X H= 3.2 m)  for 1250KVA (KTA50G3) Gensets. Sound level to be achieved 85 dBA @ 1 meter, in free Field Environment with a special paint of C5M.",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Projects_Hamriyah_Energia Webuild_01.webp",
        ],
        color: "from-black-900 to-black-500",
      },
      {
        id: "ENC-004",
        name: "40ft ISO Containerized Enclosure (C1400D5)",
        client: "Cummins",
        type: "Enclosure",
        location: "Sajja",
        description: [
          "Supply – 2 nos. a 40FT. ISO CONTAINER FOR C1400D5 GENSET. L=12.192 M X W=2.440 M & H=2.8920 M (NOISE LEVEL: 85 DB (A) @ 1.0 M / 70 DB (A) @ 7.0M)- with C4 painting, and delivered to Sashma, South Africa",
          "Supply of Box type muffler inside the container (MS material) (NOISE LEVEL: 85 DB (A) @ 1.0 M / 70 DB (A) @ 7.0M)",
          "Supply of 1750LTR single wall day fuel tank with instrumentation (Non Hazardous rated) along with internal piping",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins_01.webp",
        ],
        color: "from-black-900 to-black-500",
      },
      {
        id: "ENC-005",
        name: "20ft Modified Enclosure & Underbelly Tank",
        client: "KGL Kuwait (Orange Container)",
        type: "Enclosure",
        location: "Sajja",
        description: [
          "Design Supply 5 numbers to KGL Kuwait the Packaging of 20feet modified Enclosure for C700D5 – Genset – 1 no. and C640D5 Genset – 4 nos. . Sound level to be achieved 78 dBA @ 3 meter, / 87 dBA @ 1 meter, in free Field Environment with C5M painting",
          "Supply of 3000LTR single wall underbelly fuel tank with instrumentation (Non Hazardous rated) along with internal piping",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Orange Container_01.webp",
        ],
        color: "from-black-900 to-black-500",
      },
      {
        id: "ENC-006",
        name: "Oil & Gas Custom Enclosure (C1100D5B)",
        client: "Cummins",
        type: "Enclosure",
        location: "Sajja",
        description: [
          " Project description: Supply of 6 nos. of Custom built Enclosure for C1100D5B Genset with 2000 ltr Base Fuel Tank Noise- 85 dB(A)@ 1 mtr for Oil and Gas Project",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins Enclosure_01.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins Enclosure_02.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins Enclosure_03.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins Enclosure_04.webp",
        ],
        color: "from-black-900 to-black-500",
      },
      {
        id: "ENC-007",
        name: "20ft ISO Containerized C900D5 System",
        client: "White Container",
        type: "Enclosure",
        location: "Sajja",
        description: [
          " Design, engineering, manufacturing, inspection, and installation of a C900D5 genset housed in a custom-built enclosure in a Standard 20ft ISO container. Noise level of 85 dB(A) at 3.0 meters. A 1650-liter single-wall base fuel tank is integrated into the design.",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_White Container_01.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_White Container_02.webp",
        ],
        color: "from-black-900 to-black-500",
      },
      {
        id: "ENC-008",
        name: "20ft High Cube Containerized 700KVA",
        client: "Energia - webuild",
        type: "Enclosure",
        location: "Hamriyah",
        description: [
          "We supplied a 20ft. ISO High Cube (HC) container to ENERGIA, specifically designed to house a 700KVA genset, featuring:",
          [
            "Container Dimensions: L=6.058m x W=2.440m x H=2.890m",
            "Noise Reduction: 85 dB(A) @ 1.0m",
            "Genset Capacity: 700KVA",
          ],
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Projects_Hamriyah_Energia Webuild_01.webp",
        ],
        color: "from-black-900 to-black-500",
      },
      {
        id: "ENC-009",
        name: "Dual Cummins C1250D5A Packaging",
        client: "Engginium",
        type: "Enclosure",
        location: "Hamriyah",
        description: [
          "We packaged 2 units of Cummins C1250D5A gensets in custom-built enclosures for Engginium, featuring custom design and enhanced acoustic performance.",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Projects_Hamriyah_Engginium Cummins_01.webp",
        ],
        color: "from-black-900 to-black-500",
      },
      {
        id: "ENC-010",
        name: "40ft Fire-Rated Storage & Rack System",
        client: "ACE CRANE",
        type: "Enclosure",
        location: "Hamriyah",
        description: [
          "40 ft. used container with a 1-hour fire-rated enclosure. Features 10mm thick hot-dip galvanized chequered plate flooring and customized storage racks.",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_ACE Cranes_01.webp",
        ],
        color: "from-black-900 to-black-500",
      },
      {
        id: "ENC-011",
        name: "40ft HC Container for C1400D5",
        client: "Car and General (U) Ltd",
        type: "Enclosure",
        location: "Hamriyah",
        description: [
          "40 ft High Cube (HC) container specifically designed to house the C1400D5 genset, optimized for space and durability.",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Projects_Hamriyah_Car and General (U) Ltd_01.webp",
        ],
        color: "from-black-900 to-black-500",
      },
      {
        id: "ENC-012",
        name: "Offshore Mud Skips & Acid Transporters",
        client: "JAKSON ENERGY SOLUTIONS LLC",
        type: "Enclosure",
        location: "Hamriyah",
        description: [
          "Offshore equipment including Acid Transporters and Mud Skips for safe handling and transportation in offshore environments.",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Projects_Hamriyah_Jackson Energy Solutions LLC_01.webp",
        ],
        color: "from-black-900 to-black-500",
      },
    ],
  },
  {
    categoryId: "cat-ehouse",
    categoryName: "E-House",
    categoryDescription:
      "Prefabricated, walk-in modular outdoor enclosures to house medium and low voltage switchgear, transformers, and auxiliary equipment.",
    categoryImage:
      "https://media.arcengltd.com/project-images/ARC_E-House.webp",
    projects: [
      {
        id: "EHS-001",
        name: "Modular Industrial E-House Solution",
        client: "EXPRO",
        type: "E-House",
        location: "Sajja",
        description: [
          "Our comprehensive E-House solution includes Engineering, Manufacturing, Supply, and Commissioning for industrial and infrastructure projects.",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_EXPRO_01.webp",
        ],
        color: "from-black-900 to-black-500",
      },
    ],
  },
  {
    categoryId: "cat-powerpack",
    categoryName: "Power-Pack",
    categoryDescription:
      "High-performance rental power solutions and specialized containerized engine units designed for rapid deployment and harsh environments.",
    categoryImage:
      "https://media.arcengltd.com/project-images/ARC_PowerPack_Systems.webp",
    projects: [
      {
        id: "PPK-001",
        name: "Rental Container for KTA 38/50 Series",
        client: "Power Pack",
        type: "Power-Pack",
        location: "Sajja",
        description: [
          "Designed for KTA 38 and KTA 50 gensets, featuring noise reduction (85 dB) and durable construction for harsh environments.",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_PowerPack_01.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_PowerPack_02.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_PowerPack_03.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_PowerPack_04.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_PowerPack_05.webp",
        ],
        color: "from-black-900 to-black-500",
      },
    ],
  },
  {
    categoryId: "cat-coolingshelter",
    categoryName: "Cooling-Shelter",
    categoryDescription:
      "Custom-built active cooling shelters integrated with redundant communication and F&G safety systems for extreme temperatures.",
    categoryImage:
      "https://media.arcengltd.com/project-images/ARC_Colling-Systems.webp",
    projects: [
      {
        id: "CSL-001",
        name: "Active Cooling Shelter with F&G Safety",
        client: "Dubai Petroleum",
        type: "Cooling-Shelter",
        location: "Sajja",
        description: [
          "Custom-engineered Active Cooling Shelters with integrated advanced Fire & Gas (F&G) safety systems and redundant communication protocols.",
        ],
        imageUrls: [
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cooling Shelter_01.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cooling Shelter_02.webp",
        ],
        color: "from-black-900 to-black-500",
      },
    ],
  },
];
